import { useMemo } from "react";
const count = { current: 360 };
function nextId() {
  count.current += 1;
  return `:${count.current.toString(36)}:`;
}
function useId() {
  return useMemo(() => nextId(), []);
}
export {
  useId
};
//# sourceMappingURL=useId.js.map
